class StrengthInStoriesForm extends HTMLElement {
    constructor() {
        super();

        this.token = false;
        this.button = false;
        this.formDisabled = false;

        this.form = this.querySelector('form');

        if (this.form) {
            this.button = this.querySelector('button');

            this.init();

            this.form.addEventListener('submit', this.handleSubmit.bind(this));

            this.handleSuccess = this.handleSuccess.bind(this);
        }
    }

    init() {
        fetch(`${this.dataset.action}/init`, {
            credentials: 'include'
        })
            .then(BryanAnthonys.decodeJsonResponse)
            .then(token => {
                this.token = token;
                this.button.removeAttribute('disabled');
            })
            .catch(() => {
                this.formDisabled = true;
                this.handleError();
            });
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.formDisabled) {
            return;
        }

        this.formDisabled = true;
        this.button.classList.add('loading');
        this.button.setAttribute('disabled', 'true');

        const formData = new FormData(this.form);

        fetch(`${this.dataset.action}/save`, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "X-CSRF-TOKEN": this.token
            },
            credentials: 'include',
            body: formData
        })
            .then(BryanAnthonys.decodeJsonResponse)
            .then(() => this.handleSuccess())
            .catch(exception => {
                if (exception instanceof ResponseException) {
                    exception.resolveResponse()
                        .then(data => this.handleError(data ? JSON.parse(data).message : ''));
                } else {
                    this.handleError();
                }

                this.formDisabled = false;
                this.button.removeAttribute('disabled');
                this.button.classList.remove('loading');
            });
    }

    handleSuccess() {
        this.form.reset();
        this.formSentOnce = true;

        this.querySelector('[data-feedback]').innerHTML = BryanAnthonys.htmlReviewedForSafety(`
            <div class="status-banner status-banner--success mb-4" role="alert">
                ${this.dataset.success}
            </div>
        `);

        this.form.remove();
    }

    handleError(error = '') {
        this.querySelector('[data-feedback]').innerHTML = BryanAnthonys.htmlReviewedForSafety(
            BryanAnthonys.partiallySanitize(`
                <div class="status-banner status-banner--error mb-4" role="alert">
                    ${error ? error : this.dataset.error}
                </div>
            `)
        );
    }
}

customElements.define('strength-in-stories-form', StrengthInStoriesForm);